<template>
  <v-container>
    <taxAdjTypesUI />
  </v-container>
</template>

<script>
import taxAdjTypesUI from '../../components/shared/taxAdjTypes/taxAdjTypesList.vue';

export default {
  name: 'taxAdjTypes',
  components: {
    taxAdjTypesUI,
  },
};
</script>
